import { useState } from 'react';

import Form from 'app/components/Form';
import { formatOptions } from 'app/utils/options';

import {
  getJobs
} from 'app/services/jobs';

// default start date to current time
const defaultStartDate = new Date();

// default end date to 2 hours from now
const defaultEndDate = new Date();
defaultEndDate.setHours(defaultEndDate.getHours() + 2);

const JobForm = props => {
  const {
    job,
    onClose,
    onSubmit,
    action,
    jobConfigs,
    kiosks,
    account
  } = props;

  const jobConfigOptions = formatOptions(jobConfigs);
  const kioskOptions = [{ "label": "- None -", "value": 0 }].concat(formatOptions(kiosks));

  const getMainJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let filterModel = {
      job_id: [{
        filterClass: 'text',
        filterType: 'blank'
      }]
    }

    let resp = await getJobs({
      page,
      per_page: perPage,
      filter_model: filterModel,
      record_id: id,
    })

    return formatOptions(resp.records);
  }

  const onCustomSubmit = async (params) => {

    if (!params.kiosk_id) {
      params.kiosk_id = -1;
    }

    await onSubmit(params);
  }

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  // disable event ID field unless creating a new job
  let eventIdDisabled = !!job;

  // toggle name helperText and visible fields based on kioskNotSet
  const kioskNotSet = formState => {
    return !formState.kiosk_id || formState.kiosk_id === -999;
  }

  const nameHelperText = formState => {
    if (kioskNotSet(formState)) {
      return "This will become the name of the customer's album";
    } else {
      return 'This will become the name of the kiosk category';
    }
  }

  let fields = [
    { name: 'name', label: 'Job name', type: 'text', value: job?.name, helperText: nameHelperText, required: true },
    { name: 'event_id', label: 'Job ID', type: 'text', value: job?.event_id, disabled: eventIdDisabled, helperText: "Unique ID for the job (can't be changed)", required: true }
  ]

  // moving into catalog form
  if (kiosks && kiosks.length) {
    fields.push({ name: 'kiosk_id', label: 'Kiosk Catalog', type: 'select', value: job?.kiosk_id, valueType: 'integer', options: kioskOptions, helperText: 'Set job as a kiosk catalog', hideNoneOption: true });
  }

  if (account.feature_flags.visit_durations) {
    fields.push({ name: 'visit_duration', label: 'Visit Duration', type: 'number', value: job?.visit_duration, valueType: 'integer', helperText: "Enter the expected number of hours for a customer's visit, after which the access code may be reused" });
  }

  if (account.feature_flags.notification_delays) {
    fields.push({ name: 'notification_delay', label: 'Notification Delay', type: 'number', value: job?.notification_delay, valueType: 'integer', helperText: "Enter the number of minutes to delay sending a notification to the customer stating their photos are available" });
  }

  if (account.feature_flags.custom_defaults) {
    fields.push({ name: 'custom_defaults', label: 'Enable Custom Default Moments', type: 'checkbox', value: job?.custom_defaults, valueType: 'boolean', helperText: "Default moments uploaded to this job will only be added to customer galleries based on the customer's metadata" });
  }

  if (account.feature_flags.facial_rec) {
    fields.push({ name: 'facial_rec', label: 'Enable Facial Rec', type: 'checkbox', value: job?.facial_rec, valueType: 'boolean', helperText: "Default moments uploaded to this job will only be added to customer galleries if their face is detected in the photo" });
  }

  if (account.feature_flags.sub_jobs) {
    fields.push({ name: 'job_id', label: 'Main Job', type: 'autocomplete', value: job?.job_id, valueType: 'integer', getOptions: getMainJobOptions, helperText: 'Select main job if this is a sub job' });
  }

  let startDate = job?.start_date || defaultStartDate;
  let endDate = job?.end_date || defaultEndDate;

  // default job config to Digital Delivery (id -1)
  let jobConfigId = job?.job_config_id || -1;


  fields = fields.concat([
    { name: 'start_date', label: 'Start Date', type: 'datetime', timeLabel: 'Start Time', value: startDate, helperText: 'Date the job starts', timeHelperText: 'Time the job starts' },
    { name: 'end_date', label: 'End Date', type: 'datetime', timeLabel: 'End Time', value: endDate, helperText: 'Date the job ends', timeHelperText: 'Time the job ends' },
    { name: 'job_config_id', label: 'Product', type: 'select', value: jobConfigId, valueType: 'integer', options: jobConfigOptions, hideNoneOption: true, helperText: 'Pricing configuration for the job', required: true },
    { name: 'disable_notification', label: `Disable Customer's Notification`, type: 'checkbox', value: job?.disable_notification, valueType: 'boolean', helperText: "Disable notifications for the customer(s) under this job" }
  ]);

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit: onCustomSubmit
    }} />
  );
}

export default JobForm;
